/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Error_HintInputs */

const en_loading_error_hint = /** @type {(inputs: Loading_Error_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your connection, then try again.`)
};

const id_loading_error_hint = /** @type {(inputs: Loading_Error_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periksa koneksimu, lalu coba lagi.`)
};

/**
* | output |
* | --- |
* | "Check your connection, then try again." |
*
* @param {Loading_Error_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_error_hint = /** @type {((inputs?: Loading_Error_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Error_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_error_hint(inputs)
	return en_loading_error_hint(inputs)
});